import { render } from "./Pantry.vue?vue&type=template&id=8eb48bb2&scoped=true"
import script from "./Pantry.vue?vue&type=script&lang=js"
export * from "./Pantry.vue?vue&type=script&lang=js"

import "./Pantry.vue?vue&type=style&index=0&id=8eb48bb2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8eb48bb2"

export default script